import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import { receivingDispositionSchema } from "@redotech/redo-return-settings-common/receiving-disposition-config";
import { returnProcessingLevelSchema } from "@redotech/redo-return-settings-common/return-processing-level";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getManagedReturnsSettings = unaryRpc({
  name: "getManagedReturnsSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    billing: processingBillingConfigSchema,
    returnProcessingLevel: returnProcessingLevelSchema,
    receivingDisposition: receivingDispositionSchema.nullable(),
  }),
});
